import {connect} from "react-redux";
import InitPage from "../InitPage.jsx";
import {initLoad} from "../myResultsActions";
const mapStateToProps = (state) => {
    return {
        initLoading: state.games.initLoading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: () => dispatch(initLoad())
    }
};

const InitPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(InitPage);

export default InitPageContainer